import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';

import PreferenceListHdr from './preference-list-hdr';
import PreferenceListItem from './preference-list-item';

const PreferenceList = (props) => {
  if (!props.list.length) {
    return (
      <Typography align='center'>Preference list is empty</Typography>
    );
  } else {
    return (
      <>
        <PreferenceListHdr />
        {
          props.list.map((item, idx) => {
            return (
              <PreferenceListItem key={idx} {...item} idx={idx} handleEditPreference={props.handleEditPreference}
                handleRemovePreference={props.handleRemovePreference}
              />
            );
          })
        }
      </>
    );
  }
};

PreferenceList.propTypes = {
  list: PropTypes.array.isRequired,
  handleEditPreference: PropTypes.func.isRequired,
  handleRemovePreference: PropTypes.func.isRequired
};

export default React.memo(PreferenceList);